<template>
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <div class="spinner" v-if="showSpinner">
      </div>
      <h2>Solicitud de Trámite</h2>
      <div class="form-group">
        <label for="tipoTramite">Tipo de Trámite:</label>
        <select id="tipoTramite" v-model="selectedTipoTramite" style="width: 50%" @change="updateDetails">
          <option
            v-for="option in opcionesTipoTramite"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="comentario">Comentario del Solicitante:</label>
        <textarea id="comentario" v-model="comentario"></textarea>
      </div>

      <div class="form-group">
        <label for="costo">Costo del Trámite:</label>
        <v-icon style="font-size: 20px;">mdi-currency-eur</v-icon>
        <input type="text" id="costo" v-model="costo" readonly>
      </div>

      <div class="form-group">
        <label for="descripcion">Descripción del Trámite:</label>
        <input type="text" id="descripcion" v-model="descripcion" readonly>
      </div>

      <div class="botones">
        <button class="btn-verde" @click="sendRequest">Solicitar</button>
        <button class="btn-rojo" @click="cancelRequest">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    opcionesTipoTramite: Array,
    showSpinner: Boolean
  },
  data() {
    return {
      showModal: true,
      selectedTipoTramite: '',
      comentario: '',
      costo: '',
      descripcion: '',
      selectedTramiteId: null,
      studentComments: '',
    };
  },
  computed: {
    tramiteSeleccionadoId() {
      if (this.selectedTipoTramite) {
        const selectedOption = this.opcionesTipoTramite.find(option => option.value === this.selectedTipoTramite);
        if (selectedOption) {
          return selectedOption.id;
        }
      }
      return null;
    }
  },
  methods: {
    cancelRequest() {
      this.$emit('cancelSendRequest');
    },
    sendRequest() {
      const tramiteSeleccionado = {
        label: this.comentario,
        price: this.costo,
        descripcion: this.descripcion,
        id: this.selectedTramiteId,
        studentComment: this.studentComments
      };
      this.$emit('sendRequestStudent', tramiteSeleccionado);
    },
    updateDetails() {
  const selectedOption = this.opcionesTipoTramite.find(option => option.value === this.selectedTipoTramite);
  if (selectedOption) {
    this.costo = selectedOption.price;
    this.descripcion = selectedOption.descripcion;
    this.selectedTramiteId = selectedOption.id;
  }
}
  }
};
</script>


<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner{
  position: absolute;
  top: 45%;
  left: 48%;
  transform: translate(-50%, -50%);
  
  height : 50px;
  width : 50px;
  border-radius : 50%;
  border : 10px solid #ccc;
  border-top-color : #007bff;
  animation : spin 1s linear infinite;
}

@keyframes spin{
  0%{
    transform : rotate(0deg);
  }
  100%{
    transform : rotate(360deg);
  }
}

.modal-content {
  width: 35%;
  height: auto !important;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-width: 80%;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

textarea,
select {
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.detalle-tramite {
  margin-top: 20px;
}

.detalle-item {
  margin-bottom: 10px;
}

.botones {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-verde,
.btn-rojo {
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.btn-verde {
  background-color: green;
  color: white;
}

.btn-rojo {
  background-color: red;
  color: white;
}

@media (max-width: 768px) {
  .modal-content {
    max-width: 100%;
  }
}
</style>